import { type ComponentProps, ReactNode } from 'react';

export type LoginTemplateProps = {
  readonly errorMessage?: string;
  readonly title: string;
  readonly subtitle: string;
  readonly interactiveLink?: ReactNode;
  readonly isSubmitting?: boolean;
  readonly LoginForm: React.ElementType;
  readonly isPartner?: boolean;
  readonly contentBox?: boolean;
  readonly fullWidth?: boolean;
};

const getLoginClassNames = (
  contentBox: boolean = false,
  fullWidth: boolean = false,
) => {
  const baseClass = 'w-full';
  const wideClass = contentBox
    ? 'md:w-[500px] bg-neutral-0 shadow-md rounded p-8'
    : 'w-full md:w-96';
  return fullWidth ? baseClass : wideClass;
};
/** @deprecated -- use Template.tsx */
export function LoginTemplate<TForm extends React.ElementType>(
  props: LoginTemplateProps & ComponentProps<TForm>,
) {
  const {
    errorMessage,
    title,
    subtitle,
    LoginForm,
    contentBox,
    fullWidth,
    interactiveLink,
    ...restProps
  } = props;

  const finalClass = getLoginClassNames(contentBox, fullWidth);

  return (
    <div className={`${finalClass}`}>
      <div className="title-container mb-1">
        <div className="text-title-1 font-semibold">{title}</div>
      </div>
      <div className="subtitle-container mb-6">
        <div className="text-body-1 text-neutral-600">
          {subtitle}
          {interactiveLink}
        </div>
      </div>
      {errorMessage && (
        <div className="mb-6">
          <div
            data-testid="signInUp-error"
            className="text-body-1 text-error-500"
          >
            {errorMessage}
          </div>
        </div>
      )}
      <LoginForm {...restProps} />
    </div>
  );
}
